import { render } from "./illegal-other-count.vue?vue&type=template&id=6bb46ffe&scoped=true"
import script from "./illegal-other-count.vue?vue&type=script&lang=js"
export * from "./illegal-other-count.vue?vue&type=script&lang=js"

import "./illegal-other-count.vue?vue&type=style&index=0&id=6bb46ffe&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb46ffe"]])

export default __exports__